import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Input, Dropdown, Menu } from "antd";
import "./style.scss";
import LoginChoose from "../../../component/Head/LoginChoose";
import {  wxCodeImg } from "../../../static/option";

const navItem = [
  { title: "首页", path: "/" },
  { title: "司法拍卖", path: "/search?currentIndex=1" },
  { title: "流拍寻宝", path: "/search?currentIndex=2" },
  { title: "资产拍卖", path: "/search?currentIndex=3" },
  { title: "资产推介", path: "/search?currentIndex=4" },
  { title: "入驻" },
];


const navSettledItem = [
  { title: "经纪品牌(门店)入驻", path: "/serviceProvider" },
  { title: "独立经纪人入驻", path: "/brokerIndex" },
  { title: "债权人入驻", path: "/institution" },
  { title: "供应商入驻", path: "/supplierApply" },
];
// const navSettledItem = [
//   { title: "债权人入驻", path: "/institution" },
//   { title: "服务商入驻", path: "/serviceProvider" },
//   { title: "供应商入驻", path: "/supplierApply" },
//   { title: "经纪人入驻", path: "/brokerIndex" },
// ];

export default () => {
  const [name, setName] = useState("");
  const [showNavSettledItem, setShowNavSettledItem] = useState(false);
  const history = useHistory();

  const handleSearch = (e) => {
    let url = name ? `/search?name=${name}` : "/search";
    history.push(url);
  };

  const menu = (navSettledItem) => {
    return (
      <Menu>
        {navSettledItem.map((item) => {
          return (
            <Menu.Item
              key={item.path}
              onClick={() => {
                setShowNavSettledItem(false);
              }}
            >
              <Link to={item.path}>{item.title}</Link>
            </Menu.Item>
          );
        })}
      </Menu>
    );
  };

  return (
    <div className={"index_header"}>
      <div className={"index_header_content"}>
        <div className={"top"}>
          <div className={"top_content container-1200"}>
            <div className={"band"}>
              <img
                src="https://api.faeping.com/storage/uploads/20250403/1743664990659_%E7%9F%A9%E7%9F%B3%E9%98%B5logo2x.png"
                alt=""
              />
              矩阵资产
            </div>
            <div className={"right"}>
              <ul className={"navbar"}>
                {navItem.map((item, index) => {
                  if (index !== navItem.length - 1) {
                    return (
                      <li key={item.title}>
                        <Link to={item.path}>{item.title}</Link>
                      </li>
                    );
                  } else {
                    return (
                      <Dropdown
                        overlay={menu(navSettledItem)}
                        visible={showNavSettledItem}
                        onVisibleChange={(visible) => {
                          setShowNavSettledItem(visible);
                        }}
                        key={index}
                        placement="bottomCenter"
                      >
                        <li>
                          <a>{item.title}</a>
                        </li>
                      </Dropdown>
                    );
                  }
                })}
               
                <li>
                  小程序
                  <div className={"code-img"}>
                    <div className={"code-img-box"}>
                      <div className={"wx"}>
                        <img src={wxCodeImg} alt="" />
                        <p>微信小程序</p>
                      </div>

                    </div>
                  </div>
                </li>
              </ul>
              <LoginChoose />
            </div>
          </div>
        </div>
        <div className={" container-1200 content"}>
          <div className={"line"}></div>
          <div className={"des"}>
            <div>矩阵资产，了解你身边的资产</div>
            <p>开始你的投资之路</p>
          </div>
          <div className={"search"}>
            <div className={"inputItem"}>
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                onPressEnter={handleSearch}
                placeholder={"请输入您要搜索的标的物名称"}
              />
            </div>

            <div className={"search_btn"} onClick={handleSearch}>
              <img
                src="https://api.faeping.com/storage/uploads/20250403/1743665081188_icon%EF%BC%8F%E6%90%9C%E7%B4%A22x.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
